import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@features/modals/modal-registry.token';
import { TriviaRainModalComponent } from '@features/trivia/trivia-rain-modal/trivia-rain-modal.component';
import { TriviaRegularModalComponent } from '@features/trivia/trivia-regular-modal/trivia-regular-modal.component';

export function provideTriviaModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'TriviaRainModal', component: TriviaRainModalComponent, requiresAdmin: true }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'TriviaRegularModal', component: TriviaRegularModalComponent, requiresAdmin: true }, multi: true },
  ];
}
